import qs from 'querystring';
import { sessionStorage } from 'dibs-browser-storage';
import globalNotifications from './globalNotifications';

export const KEY_DISABLE_NOTIFICATIONS = 'no-notif';
export const KEY_ISOLATE_NOTIFICATION = 'isolate-notification';

let hasBeenInitialized = false;
let queue;

export default class Queue {
    constructor(notifications, store, relayEnvironment) {
        this.store = store;
        this.relayEnvironment = relayEnvironment;

        if (!hasBeenInitialized) {
            queue = this.buildQueue(notifications);
            hasBeenInitialized = true;
            this.runQueue();
        } else {
            throw new Error('Only one notification queue may be initialized');
        }
    }

    buildQueue(notifications) {
        const query = qs.parse(window.location.search.substr(1));
        const isolatedNotification = query[KEY_ISOLATE_NOTIFICATION];
        const fullQueue = [].concat(globalNotifications, notifications).sort((a, b) => {
            return b.priority - a.priority;
        });
        if (isolatedNotification) {
            return [fullQueue.find(item => item.name === isolatedNotification)];
        }
        if (this.noNotifications(query)) {
            return [];
        }
        return fullQueue;
    }

    noNotifications(query) {
        if (sessionStorage.getItem(KEY_DISABLE_NOTIFICATIONS) === true) {
            return true;
        }
        if (query[KEY_DISABLE_NOTIFICATIONS] === 'true') {
            sessionStorage.setItem(KEY_DISABLE_NOTIFICATIONS, true);
            return true;
        }

        return false;
    }

    _getNotificationQueue() {
        if (process.env.NODE_ENV === 'production') {
            console.error('this method is for development purposes only');
        }
        return queue;
    }

    runQueue(index = 0) {
        if (index < queue.length) {
            return queue[index].rule({ relayEnvironment: this.relayEnvironment }).then(bool => {
                if (bool) {
                    return this.store.dispatch(queue[index].action());
                } else {
                    return this.runQueue(++index);
                }
            });
        } else {
            return Promise.resolve();
        }
    }
}

export const _testReset = () => {
    hasBeenInitialized = false;
};



// WEBPACK FOOTER //
// ./src/notificationQueue/Queue.js